export const NAMESPACE_MAIN = 'app';
